import React, { memo } from 'react';
import { Route, Switch } from 'react-router-dom';

import Loadable from './components/Shared/Loadable';
import { CodeErrorPage } from './modules/CodeModule';
import NoMatchRoute from './components/Shared/NoMatchRoute';

const CodeModule = Loadable(() => import('./modules/CodeModule'));
const RecipientModule = Loadable(() => import('./modules/RecipientModule'));
const RedeemModule = Loadable(() => import('./modules/RedeemModule'));
const AcceptGiftCode = Loadable(() => import('./modules/AcceptGiftCode'));

const Routes = (): JSX.Element => (
  <Switch>
    <Route exact path="/" component={NoMatchRoute} />
    <Route path="/error/:code" exact component={CodeErrorPage} />
    <Route path="/code" exact component={CodeModule} />
    <Route path="/:hashId/redeem" exact component={RedeemModule} />
    <Route path="/code/:hashId" exact component={AcceptGiftCode} />
    <Route path="/:hashId" component={RecipientModule} />
  </Switch>
);

export default memo(Routes);
